import { render, staticRenderFns } from "./ListC.vue?vue&type=template&id=039bbbfe"
import script from "./ListC.vue?vue&type=script&lang=js"
export * from "./ListC.vue?vue&type=script&lang=js"
import style0 from "./ListC.vue?vue&type=style&index=0&id=039bbbfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports